// extracted by mini-css-extract-plugin
module.exports = {"btn_container":"FJButton_btn_container__IsYa_","btn_content":"FJButton_btn_content__Xpy3_"};